import api from '../api';

const state = {
    data: {},
    meta: {}
};

const actions = {
    getByTrades: async ({}, data) => {
        const params = {
            from: data.from,
            to: data.to,
            trades: data.trades
        };

        return api.post('/api/v1/performance/trades', params);
    }
};

const mutations = {};

const getters = {
    getById: (state) => (page) => {
        return state.data.find((item) => item.page === page);
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
